import React, { useEffect, useState } from 'react'
import { useUserService } from '../services'
import { redirectTo } from '../helpers'

declare const window: Window & { config: { iam_service_url: string; session_cookie: string; app_url: string } }

export function UserAuth({ scope, children }: { scope: string; children: React.ReactNode }) {
  const [synced, setSynced] = useState(false)
  const [failed, setFailed] = useState(false)
  const { user, sync, resetUser } = useUserService(window.config.iam_service_url, window.config.session_cookie, scope)

  useEffect(() => {
    const run = async () => {
      try {
        if (!synced && !failed) {
          await sync()
        }
        setSynced(true)
      } catch (e: any) {
        setFailed(true)

        if (e.status === 401) {
          resetUser()
          redirectTo(`${window.config.iam_service_url}/app/login?redirect_url=${window.config.app_url}`)
        } else {
          throw e
        }
      }
    }
    run()
  }, [user])

  return synced ? <>{children}</> : null
}
